import { convertDateToOnlyDateString } from "@helpers/date/dateFormat";
import { useAccountTransfer, useInvestmentTransfer } from "@rentablo/api/apiv1";
import { Values } from "../DepotTransferWizard";

export const useTransfer = () => {
  const { mutateAsync: transferDepot } = useAccountTransfer();
  const { mutateAsync: transferInvestments } = useInvestmentTransfer();

  const transfer = async (values: Values) => {
    if (
      !values.toAccountId ||
      !values.dateOfTransfer ||
      !values.fromAccountId
    ) {
      throw new Error(
        "toAccountId, dateOfTransfer, fromAccountId are required attributes"
      );
    }

    if (values.transferType === "full") {
      return await transferDepot({
        id: values.fromAccountId,
        depotTransferParams: {
          transferToAccountId: values.toAccountId,
          dateOfTransfer: convertDateToOnlyDateString(values.dateOfTransfer)!,
          transferFullLotsOnly: values.transferFullLots === "onlyFullLots",
        },
      });
    }

    const investmentsToTransfer = values.investmentsToTransfer;

    if (!investmentsToTransfer || investmentsToTransfer.length < 0) {
      throw new Error("investmentsToTransfer can not be empty");
    }

    return transferInvestments({
      investmentBatchTransferParamsList: {
        dateOfTransfer: convertDateToOnlyDateString(values.dateOfTransfer)!,
        transferToAccountId: values.toAccountId!,
        investmentBatchTransferParamsList: investmentsToTransfer
          .filter(({ numberOfLots }) => numberOfLots && numberOfLots > 0)
          .map((investment) => ({
            numberOfLots: investment.numberOfLots!,
            id: investment.id,
          })),
      },
    });
  };

  return transfer;
};
